// Primitives only: normalized values are compared with !==, so an object would always read as dirty.
type NormalizedValue = string | number | boolean | null | undefined;

export type Normalizer<V> = (value: V) => NormalizedValue;

export function isDirty<T extends object>(
  draft: T,
  initial: T,
  config: { [K in keyof T]?: Normalizer<T[K]> }
): boolean {
  return Object.keys(config).some((key) => {
    const k = key as keyof T;
    const normalize = config[k]!;
    return normalize(draft[k]) !== normalize(initial[k]);
  });
}
